




















import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/header/Header.vue';
import ActionTypes from '@/constants/action-types';

@Component({
  components: {
    Header,
  },
})
export default class App extends Vue {
  private isLoading = true;

  mounted(): void {
    this.loginAnonymously();
  }

  private async loginAnonymously(): Promise<void> {
    try {
      if (!this.$store.state.user.auth) {
        await this.$store.dispatch(`user/${ActionTypes.GuestSignIn}`);
      }
    } catch (e) {
      //
    }
    this.isLoading = false;
  }
}
